import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Message from './components/tips/index'
import store from './store'
import PhotoViewer from './components/photoViewer/index'
import vuescroll from 'vuescroll';

import 'vuescroll/dist/vuescroll.css';
// import './assets/js/flexible';//

import './assets/js/flexible.js'

Vue.use(vuescroll);
Vue.use(Message)
Vue.use(PhotoViewer)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	if (to.meta.isAuth) {  //判断是否为true
		let inviteCode = store.getters.getInviteCode
		if (inviteCode) {
			next()
		} else {
			next('/entry')
		}
	} else {
		next()//不为true往下执行
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
